import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFormProtectionContext } from './FormProtectionProvider';

const FormNavigationGuard: React.FC = () => {
  const { hasUnsavedChanges, confirmNavigation } = useFormProtectionContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // React Router의 네비게이션을 가로채기 위한 이벤트 리스너
    const handlePopState = (event: PopStateEvent) => {
      if (hasUnsavedChanges) {
        const shouldNavigate = confirmNavigation();
        if (!shouldNavigate) {
          // 뒤로 가기를 취소하고 현재 위치로 다시 이동
          window.history.pushState(null, '', location.pathname + location.search);
          event.preventDefault();
        }
      }
    };

    // popstate 이벤트 리스너 등록 (뒤로 가기/앞으로 가기 버튼)
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [hasUnsavedChanges, confirmNavigation, location]);

  return null; // 실제 UI를 렌더링하지 않는 가드 컴포넌트
};

export default FormNavigationGuard; 